import { IntentType } from '@debbie/common/dist/intents/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
const UnknownIntent = () => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement("div", null,
        lang.intents.intent,
        ": ",
        lang.intentTypes[IntentType.Unknown]));
};
export default UnknownIntent;
//# sourceMappingURL=UnknownIntent.js.map